<template>
  <div>
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">دسترسی به امکانات</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div v-if="GrpTitle != null" class="alert alert-transparent alert-success w-100">
          {{ GrpTitle }}
          [
          <a
            href="#"
            class="alert-link text-danger"
            @click="
              CopyDastresi({ DataForCopyId })
              $bvModal.show('modal-scoped')
            "
            >کپی دسترسی</a
          >
          ]
        </div>
        <div v-else class="alert alert-transparent alert-dismissible alert-info w-100">هیچ سمتی انتخاب نیست ، برای دسترسی به سمت ها بر روی سمت مورد نظر کلیک کنید .</div>
        <!-- tree -->
        <div class="row" dir="rtl">
          <div class="col-md-6 col-12">
            <treeselect class="mt-2" placeholder="برای مشاهده کلیک کنید" name="demo" :multiple="false" :options="$store.state.DefineDastresi.treeDefineDastresi_GrpShobe" :alwaysOpen="true" :noChildrenText="farsiNochild" :closeOnSelect="false" :show-count="true" v-model="value1">
              <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" class="pt-1 pb-1" :class="labelClassName" @click.prevent="ItemSelected_GrpShobe(node.id, node.label)">
                {{ node.label }}
                <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
              </label>
            </treeselect>
          </div>
          <div class="col-md-6 col-12">
            <treeselect
              v-if="$store.state.DefineDastresi.RenderList2"
              class="mt-2"
              placeholder="برای مشاهده کلیک کنید"
              name="demo"
              :multiple="false"
              :options="$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp"
              :alwaysOpen="alwaysOpen"
              :noChildrenText="farsiNochild"
              :closeOnSelect="false"
              :show-count="true"
              v-model="value2"
              :normalizer="normalizer"
            >
              <label slot="option-label" for="" :id="'LabelSlot_' + node.id" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                <div class="custom-control custom-switch d-inline">
                  <input type="checkbox" class="custom-control-input" :id="'IsMojaz_' + node.id" @click.prevent="checkBox(node.raw, node.raw.isMojaz == 1 ? 0 : 1)" v-model="node.raw.isMojaz" />
                  <label class="custom-control-label" :for="'IsMojaz_' + node.id"></label>
                </div>
                {{ node.label }}
                <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                <span v-if="!node.raw.isMojaz" class="font-weight-normal mr-2"><i class="fa fa-lock text-danger"></i></span>
                <span v-else class="font-weight-normal mr-2"><i class="fa fa-unlock text-success"></i></span>
              </label>
            </treeselect>
          </div>
        </div>
      </template>
    </card>

    <!-------------------------------------------------------------->
    <b-modal id="modal-scoped">
      <template #modal-header="{ close }">
        <b-button size="sm" variant="outline-danger" @click="close()">
          <span aria-hidden="true">&times;</span>
        </b-button>
        <h5>کپی سمت</h5>
      </template>

      <template #default>
        <b-row>
          <b-col md="12">
            <b-form-select class="form-control" v-model="SelectedSemat" dir="rtl">
              <b-form-select-option value="-1"> -- لطفا سمت مورد نظر را انتخاب کنید -- </b-form-select-option>
              <b-form-select-option v-for="itemDb in DataForCopy" :key="itemDb.id" :value="itemDb.id">
                {{ itemDb.Gname }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="success" @click="SaveCopy()"> ثـبـت کـپـی </b-button>
        <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> انصراف </b-button>
      </template>
    </b-modal>
    <!-------------------------------------------------------------->
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Widget from '@/components/Widget/Widget'
import Card from '@/components/Card/Card.vue'

export default {
  components: {
    Treeselect,
    Widget,
    Card,
  },
  data() {
    return {
      GetGrpMenu: null,
      DataCopyForSave: null,
      IdSelectedSemat: -1,
      DataForCopy: null,
      DataForCopyId: null,
      GrpTitle: null,
      alwaysOpen: true,
      value1: null,
      value2: null,
      Theme: 'bg-BlueGreen',
      farsiNochild: 'فاقد زیر مجموعه',
      treeDefineDastresi_GrpShobe: null,
      treeDefineDastresi_DastresiGrp: null,
      DataAxios_GrpShobe: {
        ArryfildValue: '',
        Method: 'Get',
        Action: this.$route.name + '/GetGrpShobe',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetGrpMenu: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'DefineDastresi/GetbvtblGrpCloudMenu',
        Token: this.$session.get('Token'),
      },
      DataAxios_UpdateDastresi: {
        ArryfildValue: {},
        Method: 'Put',
        Action: this.$route.name,
        Token: this.$session.get('Token'),
      },
      DataAxiosGetGrpMenu: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'DefineDastresi/GetbvtblGrpCloudMenu',
        Token: this.$session.get('Token'),
      },
      DataAxios_SetGrpCloudMenu: {
        ArryfildValue: {
          id: null,
        },
        Method: 'Post',
        Action: 'DefineDastresi',
        Token: this.$session.get('Token'),
      },
      UserGrpMenu: null,
      normalizer(node) {
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          isMojaz: node.isMojaz,
        }
      },
    }
  },
  computed: {
    ThemePackege() {
      return this.$store.state.Theme
    },
    SelectedSemat: {
      get() {
        return this.IdSelectedSemat
      },
      set(value) {
        this.IdSelectedSemat = value
        //console.log(value);
      },
    },
  },
  beforeMount() {
    this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp = []
    this.$GetData_Body(this.DataAxios_GrpShobe)
      .then((data) => {
        this.treeDefineDastresi_GrpShobe = data
      })
      .finally(() => {
        this.$store.state.DefineDastresi.treeDefineDastresi_GrpShobe = this.convert2(this.treeDefineDastresi_GrpShobe)
        // this.$mySweetDefaultTost(
        //   false,
        //   "بارگزاری اطلاعات باموفقیت انجام شد",
        //   "success",
        //   1500
        // );
      })
  },
  methods: {
    SaveCopy() {
      if (this.IdSelectedSemat == -1) {
        alert('هیچ سمتی انتخاب نشده است ...')
      } else {
        this.DataAxios_GetGrpMenu.ArryfildValue = {
          Id: this.IdSelectedSemat,
        }
        this.$GetData_Header(this.DataAxios_GetGrpMenu)
          .then((data) => {
            this.GetGrpMenu = data
          })
          .finally(() => {
            var dataUpdateDastresi = this.$store.state.DefineDastresi.Data_UpdateDastresi

            for (let index = 0; index < this.GetGrpMenu.length; index++) {
              const element = this.GetGrpMenu[index]

              dataUpdateDastresi.TblCloudMenuId = element.TblCloudMenuId
              dataUpdateDastresi.Id = element.IdGrpMenu
              dataUpdateDastresi.TblGrpId = this.IdSelectedSemat
              for (let J = 0; J < this.DataCopyForSave.length; J++) {
                const item = this.DataCopyForSave[J]
                if (item.TblCloudMenuId == element.TblCloudMenuId) {
                  dataUpdateDastresi.IsMojaz = item.isMojaz
                }
              }
              this.DataAxios_UpdateDastresi.ArryfildValue = dataUpdateDastresi
              this.$PostData(this.DataAxios_UpdateDastresi)
                .then(() => {})
                .finally(() => {
                  this.$mySweetDefaultTost(false, 'کپی سمت با موفقیت انجام شد', 'success', 1500)
                  document.getElementById('CancelCopy').click()
                  this.$store.state.renderComponent = false
                  this.$nextTick(() => {
                    this.$store.state.renderComponent = true
                  })
                })
            }
          })
      }
    },
    CopyDastresi(Id) {
      try {
        this.$GetData_Body(this.DataAxios_GrpShobe)
          .then((data) => {
            this.treeDefineDastresi_GrpShobe = data
            this.DataForCopy = null
            this.DataForCopy = data
          })
          .finally(() => {
            var dataCopy = this.DataForCopy.filter((i) => i.id != Id.DataForCopyId && i.id != 1)
            this.DataForCopy = dataCopy
          })
      } catch (error) {
        console.log(error)
      }
    },
    convert(arrayTree) {
      var map = {}
      for (var i = 0; i < arrayTree.length; i++) {
        var objTree = arrayTree[i]
        objTree.children = []

        map[objTree.id] = objTree

        var ParentId = objTree.ParentId || '-'

        if (!map[ParentId]) {
          map[ParentId] = {
            children: [],
          }
        }
        map[ParentId].children.push(objTree)
      }
      return map['-'].children
    },
    ItemSelected_GrpShobe(NodeId, lbl) {
      this.GrpTitle = lbl
      this.DataForCopyId = NodeId
      this.DataAxiosGetGrpMenu.ArryfildValue = {
        Id: NodeId,
      }
      this.$GetData_Header(this.DataAxiosGetGrpMenu)
        .then((data) => {
          if (data.status == 'NotOK') {
            this.DataAxios_SetGrpCloudMenu.ArryfildValue.id = NodeId
            this.$PostData(this.DataAxios_SetGrpCloudMenu)
              .then(() => {})
              .finally(() => {
                //  console.log("منو ندارد و ساخته شد");
                this.$mySweetDefaultTost(false, 'بارگزاری اطلاعات باموفقیت انجام شد', 'success', 1500)
              })
          } else {
            // console.log("NodeId=",NodeId);
            this.DataAxios_GetGrpMenu.ArryfildValue = {
              Id: NodeId,
            }
            this.$GetData_Header(this.DataAxios_GetGrpMenu)
              .then((data) => {
                //---
                this.DataCopyForSave = data
                this.treeDefineDastresi_DastresiGrp = null
                for (let index = 0; index < 1; index++) {
                  const element = data[index]
                  if (element.TblGrpId == 1) {
                    this.treeDefineDastresi_DastresiGrp = data.filter((i) => i.id != 26 && i.id != 27 && i.IndexMenu != '00                  ')
                  } else {
                    this.treeDefineDastresi_DastresiGrp = data.filter((i) => i.IndexMenu != '00                  ')
                  }
                }
              })
              .finally(() => {
                //  console.log("منو تو در تو --> خوانده شد");
                this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp = null
                var x= this.convert2(this.treeDefineDastresi_DastresiGrp)
                this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp = this.ConvertNew(this.treeDefineDastresi_DastresiGrp)

                // console.log(x);
                // console.log(this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp);
                //console.log(this.treeDefineDastresi_DastresiGrp)
                // if(NodeId==1){
                //     if(this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp.label=='دسترسي به امكانات'){
                //         console.log('label');
                //     }
                // }
                this.$mySweetDefaultTost(false, 'بارگزاری اطلاعات باموفقیت انجام شد', 'success', 1500)
              })
            this.alwaysOpen = true
          }
        })
        .finally(() => {})
    },

    ItemSelected_DastresiGrp() {},
    MojavezMakos(node, ListMenu, stateIsMojaz) {
      // if(node.id==27 && node.TblGrpId==1){

      //  return;
      // }
      ListMenu.forEach((ele) => {
        if (ele.id == node.ParentId) {
          var mosavi = 1
          var ch = ele.children.filter((i) => i != node)
          try {
            ch.forEach((child) => {
              if (child.isMojaz == node.isMojaz) {
                mosavi = 0
                throw 'BreakException'
              }
            })
            if (mosavi == 1 && ((ele.isMojaz != node.isMojaz) == 1 ? 0 : 1)) {
              // console.log(node.isMojaz , node.label , ele.isMojaz , ele.label);
              //ele.isMojaz = node.isMojaz==1?0:1;

              var dataUpdateDastresi = this.$store.state.DefineDastresi.Data_UpdateDastresi
              dataUpdateDastresi.IsMojaz = ele.isMojaz == 1 ? 0 : 1
              dataUpdateDastresi.TblCloudMenuId = ele.TblCloudMenuId
              dataUpdateDastresi.TblGrpId = ele.TblGrpId
              dataUpdateDastresi.Id = ele.IdGrpMenu
              this.DataAxios_UpdateDastresi.ArryfildValue = dataUpdateDastresi
              //console.log(dataUpdateDastresi);
              this.$PostData(this.DataAxios_UpdateDastresi).then(() => {})
              ele.isMojaz = node.isMojaz == 1 ? 0 : 1
            }
          } catch (e) {
            console.log(e)
          }

          return
        } else {
          this.MojavezMakos(node, ele.children, stateIsMojaz)
        }
      })
      var parent = this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp.filter((x) => x.id == node.ParentId)
      parent.isMojaz = stateIsMojaz
      return
    },
    checkBox(node, stateIsMojaz) {
      //console.log(node);
      var a = this.$store.state.DefineDastresi.treeDefineDastresi_DastresiGrp
      this.MojavezMakos(node, a, stateIsMojaz)
      this.Mojavez(node, stateIsMojaz)
    },
    Mojavez(node, stateIsMojaz) {
      if (node.children.length > 0) {
        //  this.$SweetQustion('هشدار تغییر دسترسی','با تغییر دسترسی '+'[ '+ node.label+' ] تمامی زیر مجموعه های آن نیز تغییر خواهند کرد! مایل به انجام این عملیات هستید؟'+' ','question','اعمال تغیرات','انصراف',node,this.isConfirmed,this.isNotConfirmed)
        var dataUpdateDastresi = this.$store.state.DefineDastresi.Data_UpdateDastresi
        dataUpdateDastresi.IsMojaz = stateIsMojaz
        dataUpdateDastresi.TblCloudMenuId = node.TblCloudMenuId
        dataUpdateDastresi.TblGrpId = node.TblGrpId
        dataUpdateDastresi.Id = node.IdGrpMenu
        this.DataAxios_UpdateDastresi.ArryfildValue = dataUpdateDastresi
        // if (node.TblGrpId == 1) {
        //   console.log('TblGrpId',node.TblGrpId);
        //   if (this.$store.state.DefineDastresi.Data_UpdateDastresi.TblCloudMenuId != 26 && this.$store.state
        //     .DefineDastresi.Data_UpdateDastresi.TblCloudMenuId != 1) {
        //     this.$PostData(this.DataAxios_UpdateDastresi).then((data) => {
        //       // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
        //       if (data != null) {
        //         // this.$mySweetDefaultTost(false,'تغییرات ذخیره شد.','success',1500);
        //         node.isMojaz = stateIsMojaz;
        //       }
        //     })
        //     node.children.forEach(element => {
        //       this.Mojavez(element, stateIsMojaz);
        //     });
        //   }
        // } else {
        // console.log("TblGrpId", node.TblGrpId);
        //console.log(dataUpdateDastresi);
        this.$PostData(this.DataAxios_UpdateDastresi).then((data) => {
          // this.$mySweetDefault(false, '... درحال بارگزاری اطلاعات', false, false);
          if (data != null) {
            // this.$mySweetDefaultTost(false,'تغییرات ذخیره شد.','success',1500);
            node.isMojaz = stateIsMojaz
          }
        })
        node.children.forEach((element) => {
          this.Mojavez(element, stateIsMojaz)
        })
        // }
      } else {
        this.$store.state.DefineDastresi.Data_UpdateDastresi.IsMojaz = stateIsMojaz
        this.$store.state.DefineDastresi.Data_UpdateDastresi.TblCloudMenuId = node.TblCloudMenuId
        this.$store.state.DefineDastresi.Data_UpdateDastresi.TblGrpId = node.TblGrpId
        this.$store.state.DefineDastresi.Data_UpdateDastresi.Id = node.IdGrpMenu
        this.DataAxios_UpdateDastresi.ArryfildValue = this.$store.state.DefineDastresi.Data_UpdateDastresi
        if (node.TblGrpId == 1) {
          if (this.$store.state.DefineDastresi.Data_UpdateDastresi.TblCloudMenuId != 27) {
            //console.log(this.DataAxios_UpdateDastresi.ArryfildValue);
            this.$PostData(this.DataAxios_UpdateDastresi).then((data) => {
              if (data != null) {
                // this.$mySweetDefaultTost(false,'تغییرات ذخیره شد.','success',1500);

                node.isMojaz = stateIsMojaz
              }
            })
          }
        } else {
          //console.log(this.DataAxios_UpdateDastresi.ArryfildValue);
          this.$PostData(this.DataAxios_UpdateDastresi).then((data) => {
            if (data != null) {
              // this.$mySweetDefaultTost(false,'تغییرات ذخیره شد.','success',1500);

              node.isMojaz = stateIsMojaz
            }
          })
        }
      }
    },

    isNotConfirmed() {},
    ConvertNew(arr){
      let A=[]
      arr.forEach((a)=>{a['children']=[]})
      for (let index = 0; index < arr.length; index++) {

          let f=arr.filter(z=>z.ParentId==arr[index].id)
          arr[index].children=(f)
         
      }
      A=arr.filter(x=>x.ParentId==null)
      // console.warn(A);
      return A

    },
    convert2(arr) {
      var flattenedArray = []
      var parentIdMap = {}

      // ایجاد نگاشتی بین parentId و شیء مربوطه
      for (var i = 0; i < arr.length; i++) {
        var item = arr[i]
        parentIdMap[item.id] = item
      }

      // تو در تو کردن آرایه بر اساس parentId
      for (var j = 0; j < arr.length; j++) {
        var currentItem = arr[j]
        var parentItem = parentIdMap[currentItem.ParentId]

        if (parentItem) {
          if (!parentItem.children) {
            parentItem.children = []
          }
          parentItem.children.push(currentItem)
        } else {
          flattenedArray.push(currentItem)
        }
      }

      return flattenedArray
    },
  },
}
</script>
<style scoped>
.vue-treeselect__label-container {
  padding: none !important;
}
.vue-treeselect--open.vue-treeselect--open-below .vue-treeselect__control {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
